export default __webpack_public_path__ + "static/media/info15_cambios_guardados_validacion_docs.d0ca78d0.png";